import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';
import { ClassCast } from '@utilities/object-helper';
import { XmfhChannel } from './xmfh-channel.model';

export class OSAData extends CompositeMeterData {
    userId: string;
    workorder?: string;
    locationComment?: string;
    account?: string;
    uploadTimestamp: number;
    locationData?: string;
    ip: string;
    port: number;
    ctmStatus: string;
    ocmStatus: string;
    tofStatus: string;
    totalPower: number;
    startFreq: number;
    slices: number;
    sliceWidth: number;
    units: string;
    spectrum: number[];
    @ClassCast(XmfhChannel)
    channels: XmfhChannel[];
    osaScanCounter: number;
}
